import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import styled from 'styled-components'
import favicon from '../images/favicon.ico'
import Header from "../components/Header"
import Footer from "../components/Footer"
import '../fonts/font-awesome/css/font-awesome.min.css'

const StyledDiv = styled.div`
  margin: 0 auto;
  maxWidth: 960px;
  padding: 0px 1.0875rem 1.45rem;
  paddingTop: 0;
`

const FooterDiv = styled.div`
  width: 100vw;
`

export default ({ children, data, title }) => (
  <div>
    <Helmet>
      <meta charSet="utf-8" />
      <meta name="description" content="Wickidcool Software information" />
      <meta
        name="keywords"
        content="development web application serverless hosting"
      />
      <title>{title}</title>
      <link rel="shortcut icon" type="image/png" href={`${favicon}`} />
    </Helmet>

    <StyledDiv>
      <Header />

      {children}

      <FooterDiv>
        <Footer />
      </FooterDiv>
    </StyledDiv>
  </div>
)

// export const query = graphql`
//       query {
//           site {
//               siteMetadata {
//                   title
//               }
//           }
//       }`
